import React from "react";
import { Navigate } from "react-router-dom";

import { useAuth } from "./AuthContext";

const PublicOnlyRoute = ({ element }) => {
    const { isAuthenticated } = useAuth();

    if (isAuthenticated) {
        return <Navigate to="/" replace />;
    }

    return element;
};

export default PublicOnlyRoute;